import React from 'react';

export const ConfigurationBadge = ({ children, tone = 'gray' }) => {
  const tones = { gray: 'bg-gray-100 text-gray-600', blue: 'bg-blue-50 text-blue-700', green: 'bg-green-50 text-green-700', amber: 'bg-amber-50 text-amber-800', red: 'bg-red-50 text-red-700', purple: 'bg-indigo-50 text-indigo-700' };
  return <span className={`inline-flex rounded-full px-2 py-0.5 text-xs font-medium ${tones[tone] || tones.gray}`}>{children}</span>;
};

const ConfigurationTable = ({ columns, children, label, empty }) => (
  <div className="overflow-x-auto rounded-xl border border-gray-200 bg-white" style={{ containerType: 'inline-size' }}>
    <table className="w-full text-left text-sm" aria-label={label}>
      <thead className="border-b border-gray-200 bg-gray-50 text-xs text-gray-500">
        <tr>{columns.map((column) => <th scope="col" key={column} className="px-4 py-3 font-semibold whitespace-nowrap">{column}</th>)}</tr>
      </thead>
      <tbody className="divide-y divide-gray-100">
        {empty ? <tr><td colSpan={columns.length} className="px-4 py-8 text-center text-gray-500">{empty}</td></tr> : children}
      </tbody>
    </table>
  </div>
);

export default ConfigurationTable;
